"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignAlgorithmModal = void 0;
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var UseEngagementAlgorithms_1 = require("Library/EngagementLibrary/UseEngagementAlgorithms");
var ModalComponent_1 = require("@CommonFrontend/Modal/ModalComponent");
var Engagement_1 = require("Common/Engagement");
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var AssignAlgorithmModal = function (_a) {
    var algorithmId = _a.algorithmId, templateId = _a.templateId, templateName = _a.templateName, onClose = _a.onClose, onApply = _a.onApply;
    var algorithms = (0, UseEngagementAlgorithms_1.useEngagementAlgorithms)().algorithms;
    var _b = __read((0, react_1.useState)(algorithmId ? algorithmId : null), 2), selectedAlgorithm = _b[0], setSelectedAlgorithm = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), isConfirming = _c[0], setIsConfirming = _c[1];
    useTemplateEngagementTelemetry(algorithms, algorithmId, templateId);
    var notifyUser = (0, inversify_react_1.useInjection)("notifyUser");
    function confirming() {
        return __awaiter(this, void 0, Promise, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsConfirming(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, onApply(selectedAlgorithm)];
                    case 2:
                        _a.sent();
                        notifyUser.success("Engagement algorithm assigned");
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        notifyUser.error("There was a problem assigning the engagement algorithm");
                        return [3, 4];
                    case 4:
                        setIsConfirming(false);
                        return [2];
                }
            });
        });
    }
    return (react_1.default.createElement(ModalComponent_1.ConfirmModal, { confirmLabel: "Assign algorithm", callback: onClose, confirming: confirming, disableConfirmButton: algorithms == undefined },
        react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.modalZIndex }, function () { return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxl" },
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m" },
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", strong: true }, "Assign algorithm"),
                react_1.default.createElement(kaleidoscope_1.Text, null,
                    "Assign the engagement algorithm for pages created from the ",
                    react_1.default.createElement(kaleidoscope_1.Text, { strong: true }, templateName),
                    " template. This will apply to any new pages created from this template.")),
            react_1.default.createElement("div", { style: { textAlign: "left" } },
                react_1.default.createElement(Engagement_1.EngagementSelect, { algorithms: algorithms !== null && algorithms !== void 0 ? algorithms : [], value: selectedAlgorithm, onChange: setSelectedAlgorithm, disabled: algorithms == undefined || isConfirming, large: true })))); })));
};
exports.AssignAlgorithmModal = AssignAlgorithmModal;
function useTemplateEngagementTelemetry(algorithms, algorithmId, templateId) {
    var serverTelemetry = (0, inversify_react_1.useInjection)("serverTelemetry");
    (0, react_1.useEffect)(function () {
        if (algorithms) {
            var algorithmObject = algorithms.find(function (a) { return a._id === algorithmId; });
            var engagementAlgorithmName = algorithmObject ? algorithmObject.name : null;
            serverTelemetry.sendTemplateEngagementPopoverViewedTelemetry({
                eventProperties: { templateId: templateId, engagementAlgorithmId: algorithmId, engagementAlgorithmName: engagementAlgorithmName },
                eventOrigin: event_tracker_types_1.EventOrigin.SinglePage,
            });
        }
    }, [algorithms, templateId, serverTelemetry]);
}
